module.exports = __webpack_public_path__ + "static/img/famale.d12f7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/toiletMAP/famale.png
// module id = SnBp
// module chunks = 1